import React from 'react';


function anoushe() {
    return(
        <>
            <section id="crew-container">
                <h2 id="crew-title">
                    FLIGHT ENGINEER
                </h2>
                <h3 id="crew-name">
                    ANOUSHEH ANSARI
                </h3>
                <p id="information" className="crew-info">
                    Anousheh Ansari is an Iranian American engineer and co-founder of Prodea Systems. Ansari was the 
                    fourth self-funded space tourist, the first self-funded woman to fly to the ISS, and the first 
                    Iranian in space.
                </p>
            </section>
        </>
    );
}

export default anoushe;